import React from "react";
import sortBy from "lodash/sortBy";
import Select from "./Select";
import { graphql } from "react-apollo";
import { gql } from "apollo-boost";

const FranchiseSelect = ({
  loading,
  error,
  franchises,
  placeholder,
  ...otherProps
}) => {
  let status;

  if (loading) status = "Loading...";
  else if (error) status = "Could not load franchises.";
  else if (!franchises) status = "There are no franchises.";

  const sortedFranchises = sortBy(franchises, "name");

  return (
    <Select
      {...otherProps}
      options={sortedFranchises}
      placeholder={status || placeholder}
      valueKey="id"
      labelKey="name"
    />
  );
};

const FranchisesQuery = gql`
  query Franchises {
    franchises(deactivated: false) {
      id
      name
    }
  }
`;

export default graphql(FranchisesQuery, {
  props: ({ ownProps, data: { loading, error, franchises } }) => ({
    loading,
    error,
    franchises
  })
})(FranchiseSelect);



// WEBPACK FOOTER //
// ./src/components/forms/FranchiseSelect.js